export default __webpack_public_path__ + "static/media/baiba-soika-vegshelf.7f9ccef8.png";